<template>
    <v-container class="d-flex align-center justify-center mt-5" fluid>
      <div class="title">
        <h5>{{ titleComputed }}</h5>
      </div>

      <div class="line-container">
          <div class="line">
            <v-tooltip
              v-for="(veiculo, index) in veiculosSinotico"
              :key="index"
              top
            >
                <template #activator="{ on, attrs }">
                <v-icon
                    v-bind="attrs"
                    v-on="on"
                    :color="color"
                    class="marker"
                    :style="{ 'z-index': 10, left: `${getPosition(veiculo.distancia)}%` }">mdi-bus-marker</v-icon>
                </template>
                <span>{{ veiculo.numero_ordem }}</span>
            </v-tooltip>
            <v-tooltip
                v-for="(ponto, index) in pontosPrincipaisSinotico"
                :key="'pp-' + index"
                open-on-click
                :open-on-hover="false"
                bottom
            >
                <template #activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="main-point"
                    :style="{ left: `${getPosition(ponto.distancia)}%` }"
                    fab x-small dark color="black"
                    retain-focus-on-click
                >
                    <v-icon color="white">mdi-flag-variant</v-icon>
                </v-btn>
                </template>
                <span>{{ ponto.nome_cerca }}</span>
            </v-tooltip>
            <v-tooltip
                v-for="(ponto, index) in pontosInteresseSinotico"
                :key="'poi-' + index"
                open-on-click
                :open-on-hover="false"
                bottom
            >
                <template #activator="{ on, attrs }">
                <div
                    v-bind="attrs"
                    v-on="on"
                    class="reference-point"
                    :style="{ left: `${getPosition(ponto.distancia)}%` }"
                ></div>
                </template>
                <span>{{ ponto.nome_cerca }}</span>
            </v-tooltip>
          </div>
      </div>
    </v-container>
  </template>
  
  <script>
  import MapUtils from '../utils/maputils';

  export default {
    props: {
      veiculos: {
        type: Array,
        required: true,
      },
      rota: {
        type: Object,
        required: true,
      },
      pontosPrincipais: {
        type: Array,
        required: true,
      },
      pontosInteresse: {
        type: Array,
        required: false
      },
      title: {
        type: String,
        required: false,
        default: ""
      },
      color: {
        type: String, 
        requires: false,
        default: "blue"
      }
    },
    data: () => ({
        veiculosSinotico: [],
        pontosPrincipaisSinotico: [],
        pontosInteresseSinotico: []
    }),
    created() {
        this.calcDistanciaVeiculos();
        this.calcDistanciaPontosPrincipais();
        this.calcDistanciaPontosInteresse();
    },
    computed: {
        distancia() {
            return MapUtils.getDistanciaTotalPolyline(this.rota);
        },
        titleComputed() {
          if (this.title === "") {
            return this.$t('operation.synoptic');
          }
          return this.title;
        }
    },
    methods: {
      calcDistanciaVeiculos() {
        this.veiculosSinotico = this.veiculos.map((v) => {
            let ponto = MapUtils.getPontoMaisProximoPolyline({lat: v.lat, lng:v.lng}, this.rota);
            let distanciaVeiculoPontoInicial = MapUtils.getDistanciaEntrePontos(ponto[1], this.pontosPrincipais[0].lat_centro, ponto[0], this.pontosPrincipais[0].lng_centro);
            return {numero_ordem: v.numero_ordem, distancia: distanciaVeiculoPontoInicial}
        })
      },
      calcDistanciaPontosPrincipais() {
        this.pontosPrincipaisSinotico = this.pontosPrincipais.map((c) => {
            if (c.id_tipo_cerca === 2) {
                return {nome_cerca: c.nome_cerca, distancia: 0};
            }

            if (c.id_tipo_cerca === 3) {
                return {nome_cerca: c.nome_cerca, distancia: this.distancia};
            }
        })
      },
      calcDistanciaPontosInteresse() {
        this.pontosInteresseSinotico = this.pontosInteresse.map((p) => {
            let ponto = MapUtils.getPontoMaisProximoPolyline({lat: p.lat_centro, lng: p.lng_centro}, this.rota);
            let distanciaPOIPontoInicial = MapUtils.getDistanciaEntrePontos(ponto[1], this.pontosPrincipais[0].lat_centro, ponto[0], this.pontosPrincipais[0].lng_centro);
            return {nome_cerca: p.nome_cerca, distancia: distanciaPOIPontoInicial}
        })
      },
      getPosition(distancia) {
        return (distancia / this.distancia) * 100;
      },
    },
  };
  </script>
  
  <style scoped>
  .title {
    position: absolute;
    color: #4a4a4a;
    font-size: medium;
    font-weight: bold;
    margin-bottom: 40px;
  }

  .line-container {
    width: 100%;
    position: relative;
  }

  .line {
    position: relative;
    width: 100%;
    height: 4px;
    background-color: #4a4a4a;
    margin-top: 20px;
  }
  
  .marker {
    position: absolute;
    top: -23px;
    transform: translateX(-50%);
  }
  
  .main-point {
    position: absolute;
    top: -14px;
    transform: translateX(-50%);
  }

  .reference-point {
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: black;
    border-radius: 50%;
    top: -3px;
    transform: translateX(-50%);
    }
  </style>
  